export default __webpack_public_path__ + "static/media/90s.5ec6508a.png";